import Router from 'vue-router';
import Components from '@/views/Components.vue';
import CurrentTariff from '@/views/CurrentTariff.vue';
import QuoteResults from '@/views/QuoteResults.vue';
import Home from '@/views/Home.vue';
import HeatPump from '@/views/HeatPump.vue';
import ElectricVehicle from '@/views/ElectricVehicle.vue';
import SolarBattery from '@/views/SolarBattery.vue';

import ErrorPage from '@/views/ErrorPage.vue';

import store from '../store';

const router = new Router({
  routes: [
    // {
    //  path: '/components',
    //  name: 'components',
    //  component: Components
    // },
    {
      path: '*',
      redirect: '/home'
    },
    {
      path: '/home',
      name: 'home',
      component: Home
    },
    {
      path: '/solar-battery',
      name: 'solarBattery',
      component: SolarBattery
    },
    {
      path: '/electric-vehicle',
      name: 'electricVehicle',
      component: ElectricVehicle
    },
    {
      path: '/heat-pump',
      name: 'heatPump',
      component: HeatPump
    },
    {
      path: '/switch/home-energy',
      name: 'currentTariff',
      component: CurrentTariff
    },
    {
      path: '/results',
      name: 'quoteResults',
      component: QuoteResults
    },
    {
      path: '/error/:status',
      name: 'error',
      component: ErrorPage
    }
  ],
  scrollBehavior() {
    return { x: 0, y: 0 };
  }
});

router.beforeEach(async (to, from, next) => {
  if (to.name != 'error') {
    await store.dispatch('token/getToken');
  }

  next();
});

router.afterEach((to, from) => {
  store.dispatch('history/updateCurrentRoute', to);
  store.dispatch('history/updatePreviousRoute', from);
});

export default router;
